import { render, staticRenderFns } from "./FlashElement.vue?vue&type=template&id=be6c5ebe&scoped=true&"
import script from "./FlashElement.vue?vue&type=script&lang=js&"
export * from "./FlashElement.vue?vue&type=script&lang=js&"
import style0 from "./FlashElement.vue?vue&type=style&index=0&id=be6c5ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6c5ebe",
  null
  
)

export default component.exports